export default __webpack_public_path__ + "static/david_avatar-c3c63661bd7c18922835037ff850cdfa.png";